  var numberOfDays = 3;
var today = new Date();
var start = getNextStartDate(today);
var end = getNextEndDate(today);

var timer = setInterval(function() {
  var differenceTime, dd, hh, mm, ss, str;
  var now = new Date();
    var hours = document.querySelector('.hoursCounter');
  var minutes = document.querySelector('.minutesCounter');
  var seconds =  document.querySelector('.secondsCounter');

  if (now >= end) {
    start = getNextStartDate(now);
    end = getNextEndDate(now);
  } else {
    differenceTime = end - now;

    hh = parseInt(differenceTime / (60 * 60 * 1000)) % 24;
    mm = parseInt(differenceTime / (1000 * 60)) % 60;
    ss = parseInt(differenceTime / 1000) % 60;

    hours.innerHTML = format(hh);
    minutes.innerHTML = format(mm);
    seconds.innerHTML = format(ss);
  }
}, 1000);

document.addEventListener("DOMContentLoaded", () => {
  const searchParams = new URL(document.location).searchParams;
    let strickyTrigger = document.querySelector('.wide_content .half');
  if(searchParams.get("force") == 'offer1_1') {
      strickyTrigger = document.querySelector('.offer_new_section');
  }
  let strickyCtas = document.querySelectorAll('.stickyCta');

  window.addEventListener('scroll', function() {
      let scroll = window.scrollY;
      if (scroll > strickyTrigger.offsetTop) {
          console.log('in');
        strickyCtas.forEach(function(strickyCta, index) {
           strickyCta.classList.add("visible");
        });
        
      } else {
         console.log('out'); 
        strickyCtas.forEach(function(strickyCta, index) {
           strickyCta.classList.remove("visible");
        });
      }
  });
});



function getNextEndDate(fromDate) {
  return new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate() + numberOfDays);
}

function getNextStartDate(currentDate) {
  var currentDay = currentDate.getDate();
  var index = Math.ceil(currentDay / 3);
  var nextStartDay = 1 + numberOfDays * index
  return new Date(currentDate.getFullYear(), currentDate.getMonth(), nextStartDay);
}

function format(num) {
  return (9 < num) ? num : "0" + num;
};

document.addEventListener("DOMContentLoaded", () => {
const searchParams = new URL(document.location).searchParams;
var body = document.body;
var offer1El = document.querySelectorAll('.offer_1');
var offer2El = document.querySelectorAll('.offer_2');

if(searchParams.get("force")) {
  if(searchParams.get("force") == 'offer1') {
      body.classList.add("body_offer_old");
    offer1El.forEach(function(ele1, index) {
      ele1.style.display = 'block';
    });
    offer2El.forEach(function(ele2, index) {
       ele2.style.display = 'none';
    });
  }

   if(searchParams.get("force") == 'offer2') {
       body.classList.add("body_offer_old");
     offer1El.forEach(function(ele1, index) {
       ele1.style.display = 'none';
    });
    offer2El.forEach(function(ele2, index) {
      ele2.style.display = 'block';
    });
  }
  if(searchParams.get("force") == 'offer1_1') {
    body.classList.add("body_offer_new");
  }
} else {
  body.classList.add("body_offer_old");
}
});





function ctaClick () {

  let discountCode = 'HALLO';
  if (discountCode) {
    document.cookie = `discount_code=${discountCode}; path=/`;
    fetch(`/discount/${discountCode}`)
    .then(function() {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          updates: {},
        }),
      }) 
    .then(response => response.json())
    .then(response => {
      jQuery.post('/cart/add.js', {
         items: [
        {
          quantity: 1,
          id: 44448901366025,
          properties: {
            'Für Neukunden ab 49€ Gratis CODE': '“HALLO” (wird an der Kasse abgezogen)'
          }
        },
        // {
        //   quantity: 1,
        //   id: 44559219982601
        // },
      ]
      }).always(function() {
        //let popUp = document.querySelector('.popUp');
        //popUp.style.display = 'block';
          location.href = 'https://picmondoo.de/collections/diamond-painting';
      });

    });
    })
    .catch(function(error) {
      console.error('Error:', error);
    });
  }
  

}

function ctaClickOffer2 () {
  
  let discountCode = 'HALLO2';
  if (discountCode) {
    document.cookie = `discount_code=${discountCode}; path=/`;
    fetch(`/discount/${discountCode}`)
    .then(function() {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          updates: {},
        }),
      }) 
    .then(response => response.json())
    .then(response => {
      jQuery.post('/cart/add.js', {
         items: [
        {
          // quantity: 1,
          // id: 44559219982601
        },
      ]
      }).always(function() {
          location.href = 'https://picmondoo.de/collections/diamond-painting';
  });

    });
    })
    .catch(function(error) {
      console.error('Error:', error);
    });
  }
}

function ctaClickMnz () {
    let discountCode = 'Malen';
  if (discountCode) {
    document.cookie = `discount_code=${discountCode}; path=/`;
    fetch(`/discount/${discountCode}`)
    .then(function() {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          updates: {},
        }),
      }) 
    .then(response => response.json())
    .then(response => {
      jQuery.post('/cart/add.js', {
         items: [
        {
          quantity: 1,
          id: 44448965624073,
          properties: {
            'Info': 'Mit Code „Malen“ gratis'
          }
        }
      ]
      }).always(function() {
          location.href = 'https://picmondoo.de/collections/malen-nach-zahlen';
  });

    });
    })
    .catch(function(error) {
      console.error('Error:', error);
    });
  }
}

function ctaClickMnzOffer2 () {

  let discountCode = 'hallo2';
  if (discountCode) {
    document.cookie = `discount_code=${discountCode}; path=/`;
    fetch(`/discount/${discountCode}`)
    .then(function() {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          updates: {},
        }),
      }) 
    .then(response => response.json())
    .then(response => {
      location.href = 'https://picmondoo.de/collections/malen-nach-zahlen';
    });
    })
    .catch(function(error) {
      console.error('Error:', error);
    });
  }
}

